import { render, staticRenderFns } from "./EditSubCategoryAdmin.vue?vue&type=template&id=34397dfc&"
import script from "./EditSubCategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./EditSubCategoryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports